import i18nInstance from 'i18n/i18nInstance'
import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { paths } from '@mc/paths'

const t = i18nInstance.getFixedT(null, '@mc/next')

export const getGiftingFaqSection = (): Section => ({
  title: t('faq.gifting.title'),
  questions: [
    {
      title: t('faq.gifting.question1'),
      uuid: 'faq.gifting.question1',
      answer: t('faq.gifting.answer1'),
    },
    {
      title: t('faq.gifting.question2'),
      uuid: 'faq.gifting.question2',
      answer: t('faq.gifting.answer2'),
    },
    {
      title: t('faq.gifting.question3'),
      uuid: 'faq.gifting.question3',
      answer: (
        <Trans i18nKey='faq.gifting.answer3' ns='@mc/next'>
          {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
          <a
            className='mc-text--link'
            href={paths.giftSupport}
            target='_blank'
            rel='noreferrer'
          />
        </Trans>
      ),
    },
    {
      title: t('faq.gifting.question4'),
      uuid: 'faq.gifting.question4',
      answer: t('faq.gifting.answer4'),
    },
    {
      title: t('faq.gifting.question5'),
      uuid: 'faq.gifting.question5',
      answer: (
        <Trans i18nKey='faq.gifting.answer5' ns='@mc/next'>
          <br />
          {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
          <a
            className='mc-text--link'
            href={paths.giftTerms}
            target='_blank'
            rel='noreferrer'
          />
        </Trans>
      ),
    },
    {
      title: t('faq.gifting.question6'),
      uuid: 'faq.gifting.question6',
      answer: (
        <Trans i18nKey='faq.gifting.answer6' ns='@mc/next'>
          {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
          <a
            className='mc-text--link'
            href={paths.helpCenterMasterClass}
            target='_blank'
            rel='noreferrer'
          />
        </Trans>
      ),
    },
  ],
})
